// extracted by mini-css-extract-plugin
export default {"archiveBox":"Archive_archiveBox__h7Hqc","archive":"Archive_archive__ZG4j3","unarchive":"Archive_unarchive__8wNDh","label":"Archive_label__QUvSl"};